import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserManagementService } from '../../service/user-management.service';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Message } from 'primeng/components/common/api';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router } from '@angular/router';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.css']
})
export class UpdateUserComponent implements OnInit {
  roleDDL: any = [];
  //selecteRole: string;
  selecteRoles = [];
  result: any = [];
  customerMultiDDL: SelectItem[];
  selectedMultiDDL: number[] = [];
  customerSingleDDL: SelectItem[];
  selectedSingleDDL: number[] = [];
  user = {
    Id: '',
    UserName: '',
    PhoneNumber: '',
    FirstName: '',
    LastName: '',
    //selecteRole: '',
    selecteRoles: [],
    selectedDDL: [],
    OtpTypeId: null
  };
  message: string = '';
  msgs: Message[] = [];
  constructor(public route: ActivatedRoute, public dataService: UserManagementService, public router: Router) {
    this.dataService.getUser(this.route.snapshot.paramMap.get('id')).subscribe(result => {
      this.result = result;
      this.dataService.getRoleDDL().subscribe((res: any) => {
        this.roleDDL = res;
        // this.selecteRole = this.result.Roles[0];
        this.selecteRoles = this.result.Roles;

        // this.roleDDL[6].disabled = true;
        let supplierRole = this.selecteRoles.find(s=> (s == 'Supplier'));
        let customerRole = this.selecteRoles.find(s=> (s == 'Customer'));

        if (supplierRole) {
          this.roleDDL.find(s=> (s.value=='Customer')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerConfirm')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerPaymentConfirm')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerPaymentSetDate')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerRedirectTreatment')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerPaymentConfirmOwnOnly')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'Administration')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'Support')).disabled = true;

        } else if (customerRole) {
          this.roleDDL.find(s=> (s.value == 'Supplier')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'Administration')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'Support')).disabled = true;
        } else if (!supplierRole && !customerRole) {
          this.roleDDL.find(s=> (s.value == 'Supplier')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'Customer')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerConfirm')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerPaymentConfirm')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerPaymentSetDate')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerRedirectTreatment')).disabled = true;
          this.roleDDL.find(s=> (s.value == 'CustomerPaymentConfirmOwnOnly')).disabled = true;
        }



      });
    });
    

  }

  ngOnInit() {
  }


  onSubmit(f: NgForm) {
    if (f.valid) {
      this.user.Id = this.route.snapshot.paramMap.get('id');
      this.user.UserName = f.value.UserName;
      this.user.PhoneNumber = f.value.PhoneNumber;
      this.user.FirstName = f.value.FirstName;
      this.user.LastName = f.value.LastName;
      this.user.OtpTypeId = f.value.OtpTypeId;
      // this.user.selecteRole = f.value.selecteRole;
      this.user.selecteRoles = f.value.selecteRoles;
      if (f.value.selectedMultiDDL !== undefined) {
        this.user.selectedDDL = this.selectedMultiDDL;
      }
      else if (f.value.selectedSingleDDL !== undefined) {
        this.user.selectedDDL.push(this.selectedSingleDDL);
      }
      this.dataService.updateUser(this.user).subscribe(res => {
        this.message = res.toString();
        if (this.message === '0') {
          this.showSuccess();
          setTimeout(() => {
            this.router.navigate(['list-user']);
          }, 1500);
        }
        else if (this.message === '1') {
          this.showError();
        }
      });
    }
  }
  showSuccess() {
    this.msgs = [];
    this.msgs.push({ severity: 'success', summary: '', detail: ' העדכון נשמר בהצלחה' });
  }

  showError() {
    this.msgs = [];
    this.msgs.push({ severity: 'error', summary: '', detail: ' שגיאה בעדכון' });
  }
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/user-management/update-user/update-user.component.ts